<div class="modal-container">
    <div class="modal-header">
        <h2>{{ 'profile.create-new-company' | translate }}</h2>
        <button class="close-btn" (click)="onCancel()" aria-label="Close">
            <mat-icon>close</mat-icon>
        </button>
    </div>

    <div class="modal-content">
        <div class="business-info-form" *ngIf="companyFormStep === 1" [formGroup]="companyForm">
            <div class="order-form">
                <label for="business-name">{{'onboarding.company-form.business-name' | translate}}</label>
                <div class="search-input">
                    <input type="text" id="business-name" formControlName="businessNumber"
                        placeholder="{{'onboarding.company-form.search-input-placeholder' | translate}}"
                        class="form-control" />
                    <button type="button" class="search-btn" (click)="searchBusiness()"
                        [attr.aria-label]="'onboarding.search-tooltip' | translate"
                        [disabled]="isSearchingBusiness">
                        <span *ngIf="isSearchingBusiness" class="btn-loader search-btn-loader"></span>
                        <mat-icon *ngIf="!isSearchingBusiness" [matTooltip]="'onboarding.search-tooltip' | translate" matTooltipPosition="above" class="search-icon" color="primary">search</mat-icon>
                    </button>
                </div>

                <div *ngIf="searchError" class="error-message">
                    <mat-icon color="warn">error</mat-icon>
                    <p>{{searchError}}</p>
                </div>
                <!-- Search Results -->
                <div class="search-results" *ngIf="searchResults.length > 0">
                    <div class="search-result-item" *ngFor="let company of searchResults"
                        (click)="selectCompany(company)" aria-label="Select Company">
                        <div class="company-info">
                            <h4>{{company.companyName | titlecase}}</h4>
                            <p>{{company.idNumber}}</p>
                            <p>{{company.address}}, {{company.city}}</p>
                        </div>
                        <mat-icon>arrow_forward</mat-icon>
                    </div>
                </div>
            </div>
        </div>

        <!-- Company Details Form -->
        <div class="company-details-form" *ngIf="companyFormStep === 2">
            <div class="order-form">
                <div class="company-details">
                    <div class="company-header">
                        <h3>{{'onboarding.company-form.company-details-form.title' | translate}}</h3>
                        <div class="company-verified">
                            <mat-icon>verified</mat-icon>
                            {{'onboarding.company-form.company-details-form.verified' | translate}}
                        </div>
                    </div>

                    <div class="company-info-grid">
                        <div class="info-group">
                            <label>{{'onboarding.company-form.company-details-form.company-name' | translate}}</label>
                            <p>{{selectedCompany?.companyName || '-'}}</p>
                        </div>

                        <div class="info-group">
                            <label>{{'onboarding.company-form.company-details-form.organization-number' |
                                translate}}</label>
                            <p>{{selectedCompany?.idNumber || '-'}}</p>
                        </div>

                        <div class="info-group full-width">
                            <label>{{'onboarding.company-form.company-details-form.address' | translate}}</label>
                            <p>{{selectedCompany?.address || '-'}}, {{selectedCompany?.city || '-'}}</p>
                        </div>

                        <div class="info-group">
                            <label>{{'onboarding.company-form.company-details-form.country' | translate}}</label>
                            <p>{{selectedCompany?.country || '-'}}</p>
                        </div>

                        <div class="info-group">
                            <label>{{'onboarding.company-form.company-details-form.email' | translate}}</label>
                            <p>{{selectedCompany?.email || employee?.email}}</p>
                        </div>

                        <div class="info-group">
                            <label>{{'onboarding.company-form.company-details-form.phone' | translate}}</label>
                            <p>{{selectedCompany?.phone || '-'}}</p>
                        </div>

                        <div class="info-group">
                            <label>{{'onboarding.company-form.company-details-form.website' | translate}}</label>
                            <p>{{selectedCompany?.customerWebsite || '-'}}</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<div class="modal-actions" *ngIf="companyFormStep === 2">
    <div class="action-buttons">
        <button class="search-again-btn" (click)="searchAgain()" aria-label="Search Again">
            {{'onboarding.company-form.company-details-form.search-again' | translate}}
        </button>
        <button class="confirm-btn" mat-flat-button color="primary" *ngIf="selectedCompany"
            (click)="confirmCompanyDetails()" aria-label="Confirm Company">
            {{'onboarding.company-form.company-details-form.confirm-company-button' | translate}}
            <mat-icon>check</mat-icon>
        </button>
    </div>
</div>